import SVG from "svg.js";
import { Patient } from "@/store/modules/patient/types";
import { InfoWindow } from "./InfoWindow";
import { BodyConfig } from ".";
import { Store } from "vuex";
import _ from "lodash";

export class EblText extends InfoWindow {
  shiftX = 70;
  shiftY = 20;
  linesToBold = [];
  linesToColor: Array<{ color: string; index: number }> = [];

  constructor(config: BodyConfig, container: SVG.Container, store: Store<any>) {
    super(config, container, store);
    this.shiftContent();
  }

  getExtraData(patient: Patient) {
    const ebl = _.get(patient, "body.atoms.ebl", null);
    if (!ebl) {
      return;
    }
    this.extraData = {
      ebl: ebl.legend
    };
    this.linesToColor = [];
    if (ebl.level >= 5) {
      this.linesToColor.push({ color: "red", index: 0 });
    }
  }
}
